define('services/analytics/queueAnalyticsService',[
    'lib/bluebird',
    'lib/lodash4',
    'lib/knockout',
    'services/analyticsService',
    'services/apiCore',
    'services/authService',
    'models/AnalyticsData'
], function (
    Promise,
    _,
    ko,
    analyticsService,
    apiCore,
    authService
) {
    'use strict';

    /*
    Constants Anayltics API.
     */
    var QUEUES_DIMENSION_NAME = "queueId";

    var QUEUE_DATASOURCE = {
        QUEUES_CONVERSATIONS_METRICS: "conversations/aggregates/query",
        QUEUES_CONVERSATIONS_DETAILS: "conversations/details/query",
        QUEUES_MEMBERS_METRICS: "queues/observations/query"
    };

    var queueAnalytics = {

        /**
         * Queries the Analytics Service with one filter for a queue.
         * @param  {String} queueId
         * @param  {String} interval - ISO8601 specified time interval, indicating the time range for the data requested
         * @return {promise} queueData - promise that resolves with the response from the server
         */
        loadQueueData: function (queueId, interval, options) {
            if (!authService.hasAuthorization({ all: ['perm:analytics:conversationAggregate:view'], ignoreDivisions: true })) {
                return Promise.reject(new Error("Permission analytics:conversationAggregate:view needed"));
            }

            var id = ko.unwrap(queueId);
            var intervalArg = ko.unwrap(interval);

            var queueData = analyticsService.execAggregateQuery(
                id,
                QUEUE_DATASOURCE.QUEUES_CONVERSATIONS_METRICS,
                [QUEUES_DIMENSION_NAME],
                intervalArg,
                options
            );
            return queueData;
        },

        loadQueueInteractions: function (payload) {
            if (!authService.hasAuthorization({ all: ['perm:analytics:conversationDetail:view'], ignoreDivisions: true })) {
                return Promise.reject(new Error("Permission analytics:conversationDetail:view needed"));
            }

            return apiCore.v2.post('/analytics/' + QUEUE_DATASOURCE.QUEUES_CONVERSATIONS_DETAILS, payload);
        },

        /**
         * Queries the Analytics Service with multiple filters (disjunction filters)
         * @param  {String} queueIds - IDs of the queues
         * @param  {String} interval - ISO8601 specified time interval, indicating the time range for the data requested
         * @return {promise} queuesData - promise that resolves with the response from the server
         */
        loadQueuesData: function (queueIds, interval, options) {
            if (!authService.hasAuthorization({ all: ['perm:analytics:conversationAggregate:view'], ignoreDivisions: true })) {
                return Promise.reject(new Error("Permission analytics:conversationAggregate:view needed"));
            }

            var idArr = ko.unwrap(queueIds);
            var intervalArg = ko.unwrap(interval);

            var queuesData = analyticsService.execDisjunctionAggregateQuery(
                idArr,
                QUEUE_DATASOURCE.QUEUES_CONVERSATIONS_METRICS,
                [QUEUES_DIMENSION_NAME],
                intervalArg,
                options
            );
            return queuesData;
        },

        loadQueuesObservations: function (queueIds, interval, options) {
            if (!authService.hasAuthorization({ all: ['perm:analytics:conversationAggregate:view'], ignoreDivisions: true })) {
                return Promise.reject(new Error("Permission analytics:conversationAggregate:view needed"));
            }

            var idArr = ko.unwrap(queueIds);
            var intervalArg = ko.unwrap(interval);
            var queuesData = analyticsService.execDisjunctionAggregateQuery(
                idArr,
                QUEUE_DATASOURCE.QUEUES_MEMBERS_METRICS,
                [QUEUES_DIMENSION_NAME],
                intervalArg,
                options
            );
            return queuesData;
        },

        /**
         * Queries the Analytics Service with multiple filters (disjunction filters)
         * @param  {String} queueIds - IDs of the queues
         * @param  {String} interval - ISO8601 specified time interval, indicating the time range for the data requested
         * @return {promise} queuesData - promise that resolves with the response from the server
         */
        loadQueuesMembersData: function (queueIds, interval, options) {
            if (!authService.hasAuthorization({ all: ['perm:analytics:queueObservation:view'], ignoreDivisions: true })) {
                return Promise.reject(new Error("Permission analytics:queueObservation:view needed"));
            }

            var idArr = ko.unwrap(queueIds);
            var intervalArg = ko.unwrap(interval);

            var queuesData = analyticsService.execDisjunctionAggregateQuery(
                idArr,
                QUEUE_DATASOURCE.QUEUES_MEMBERS_METRICS,
                [QUEUES_DIMENSION_NAME],
                intervalArg,
                options
            );
            return queuesData;
        }

    };

    return queueAnalytics;

});

